'use client';

import { useScrollDepthTracking } from './hooks/useScrollDepthTracking';

/**
 * Component that tracks scroll depth events and sends them to Segment analytics.
 * This component doesn't render anything visible - it only handles tracking.
 *
 * @example
 * ```tsx
 * <ScrollDepthTracker />
 * ```
 */
export const ScrollDepthTracker = () => {
  // Initialize scroll depth tracking
  useScrollDepthTracking();

  // This component doesn't render anything
  return null;
};
